import axios from "axios";
import { getApiErrorMessage } from "../../utils/getApiErrorMessage";

export const downloadingGoodsReceiveNote = (obj, id) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        `/purchaseorders/goodsReceive/` +
        id,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const CreateGoodsReturnNote = (obj, createGoodsReturnNoteBody, id) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE + `/purchaseorders/goodsReturn/` + id;
  return axios
    .post(url, createGoodsReturnNoteBody, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};
export const DeleteUrlPdf = (id, pdfUrl, obj) => {
  return axios
    .delete(
      `${process.env.REACT_APP_NOT_SECRET_CODE}/purchaseorders/goodsReturn/delete/${id}?url=${pdfUrl}`,
      {
        headers: {
          "Content-Type": "application/json",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getallUsers = (name, page, obj) => {
  var url = "";
  if (page == "") {
    url = process.env.REACT_APP_NOT_SECRET_CODE + "/users?name=" + name;
  } else {
    url = process.env.REACT_APP_NOT_SECRET_CODE + "/users?name=" + name;
  }
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const searchMedicationForOrder = (title, city, page, obj, storeId = "") => {
  let url = "";

  url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/medications?search_medication=" +
    title +
    "&records_per_page=100000000&country=" +
    city;

  if (storeId) {
    url += "&store_id=" + storeId;
  }

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const SendGoodReturnValue = (obj, orderItemsform) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + `/goodsReturn`;
  return axios
    .post(url, orderItemsform, {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(
        "Error Response:",
        error.response ? error.response.data : getApiErrorMessage(error),
      );
      throw error;
    });
};

export const UpdateGoodReturnValue = (obj, id, orderItemsform) => {
  const url = `${process.env.REACT_APP_NOT_SECRET_CODE}/goodsReturn/${id}`;
  return axios
    .put(url, orderItemsform, {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(
        "Error Response:",
        error.response ? error.response.data : getApiErrorMessage(error),
      );
      throw error;
    });
};

export const DeleteGoodReturnValue = (obj, id) => {
  const url = `${process.env.REACT_APP_NOT_SECRET_CODE}/goodsReturn/delete/${id}`;
  return axios
    .delete(url, {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(
        "Error Response:",
        error.response ? error.response.data : getApiErrorMessage(error),
      );
      throw error;
    });
};

export const getGoodRetunShow = (obj, page) => {
  const url = `${process.env.REACT_APP_NOT_SECRET_CODE}/goodsReturn?page=${page}`;

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: `Bearer ${obj}`,
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      console.error("API Error:", error);
      throw error;
    });
};

export const getAllMedicationCategory = (obj) => {
  const url = `${process.env.REACT_APP_NOT_SECRET_CODE}/medicationCategories-all`;
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      console.error("API Error:", error);
      throw error;
    });
};

export const AddMedicationFromPO = (medicationBody, obj) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + `/medications`;
  return axios
    .post(url, medicationBody, {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(
        "Error Response:",
        error.response ? error.response.data : getApiErrorMessage(error),
      );
      throw error;
    });
};

export const getAvailableStock = (medicationId, storeId, obj) => {
  const url = `${process.env.REACT_APP_NOT_SECRET_CODE}/getAvailableQuantity/${medicationId}?store=${storeId}`;
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      console.error("API Error:", error);
      throw error;
    });
};
